import ExchangeRate from '../exchange-rate'

export const ActionOverview = () => {
  return (
    <div className="flex items-center justify-end mr-3 -my-2 text-legend">
      <ExchangeRate />
    </div>
  )
}

export default ActionOverview
